import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';

const list = createReducer(
  {},
  {
    [ActionTypes.FETCH_TOPIC_SUCCESS]: (state, { payload }) =>
      Object.assign({}, state, { [payload.key]: payload })
  }
);

const status = createReducer(
  {},
  {
    [ActionTypes.FETCH_TOPIC_SUCCESS]: (state, { type, payload }) =>
      Object.assign({}, state, { [payload.key]: type })
  }
);

export default combineReducers({
  list,
  status
});
